// STYD: tasjesknop op de productkaart legt standaardproducten (zonder opties) direct in de winkelwagen.
// Producten met opties hebben geen data-add-variant-id en linken gewoon naar de productpagina.
(function () {
  if (window.stydCardCartReady) return;
  window.stydCardCartReady = true;

  function sectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : '';
  }

  async function addToCart(button) {
    const variantId = Number(button.dataset.addVariantId);
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const sections = cart && typeof cart.getSectionsToRender === 'function'
      ? cart.getSectionsToRender().map((section) => section.id)
      : ['cart-icon-bubble'];

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || response.statusText);

      if (cart && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else if (data.sections && data.sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = sectionInnerHTML(data.sections['cart-icon-bubble']);
      }

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 2000);
    } catch (error) {
      // Lukt direct toevoegen niet (bijv. voorraad), stuur de klant naar de productpagina.
      window.location.href = button.getAttribute('href');
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.styd-card__cart-btn[data-add-variant-id]');
    if (!button) return;
    event.preventDefault();
    if (button.classList.contains('is-loading')) return;
    addToCart(button);
  });
})();
